import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const ConciergeKnowledgeSchema = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  whenToUse: z.string(),
  title: z.string(),
  knowledge: z.string(),
  enabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
  expiresAt: z.date().nullish(),
  isSuggestedKnowledge: z.boolean().optional(),
  suggestedKnowledgeInfo: z
    .object({ referencedConversationIds: z.array(z.string()) })
    .optional(),
  recommendedProductIds: z.array(z.string()).max(5).optional(),
  numberOfUses: z.number().int().nonnegative().default(0),
});
export type ConciergeKnowledge = z.infer<typeof ConciergeKnowledgeSchema>;
